import {Directive, Input, Output, ElementRef, forwardRef, AfterViewInit, OnInit, OnDestroy, EventEmitter} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Moment } from 'moment';

declare var $:any;

const noop = ()=>{};
const DATEPICKER_INPUT_VALUE_CONTROL_ACCESSOR:any={
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(()=>DatePickerDirective),
    multi: true
};

@Directive({ 
    selector: '[datepicker]',
    providers: [DATEPICKER_INPUT_VALUE_CONTROL_ACCESSOR]
})
export class DatePickerDirective implements OnInit, OnDestroy, AfterViewInit, ControlValueAccessor {
    @Input() ngModel;
    @Input() minDate;
    @Input() maxDate;
    @Input() showTime;
    
    private onTouchedCallback: ()=>void = noop;
    private onChangeCallback: (_:any)=>void = noop;
    private format = 'DD/MM/YYYY HH:mm';

    constructor(private el:ElementRef){}

    ngOnInit(){
        if(this.showTime == true)
            this.format = 'DD/MM/YYYY HH:mm';
        else
            this.format = 'DD/MM/YYYY';
    }

    ngOnDestroy(){
        $(this.el.nativeElement).datetimepicker().data('DateTimePicker').destroy();
    }

    ngAfterViewInit(){
        $(this.el.nativeElement).datetimepicker({ format: this.format, minDate: this.minDate, maxDate:this.maxDate }).on('dp.change', e=>{
            let date: Moment = (<Moment>(<any>e).date);
            if (date){
                let value = date.format(this.format);
                this.onChangeCallback(value);
            }
            else{
                this.onChangeCallback("");
            }
        });
        //this.writeValue(this.ngModel);
    }

    writeValue(value:any){
        $(this.el.nativeElement)
            .datetimepicker({ format: this.format, minDate: this.minDate, maxDate:this.maxDate })
            .data('DateTimePicker')
            .date(value);
    }

    registerOnChange(fn:any){
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn:any){
        this.onTouchedCallback = fn;
    }    
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/directives/datepicker.ts